import { EditorStore } from '@candulabs/craft';

import { BuiltInComponents } from 'craft/constants';

export const getCollectionId = (nodeId: string | undefined, query: EditorStore['query']) =>
  query
    ?.node(nodeId)
    ?.ancestors(true)
    .filter((nid: string) => query.node(nid).node.data.name === BuiltInComponents.Collection);

export const getCollectionIdsFromCollection = (nodes: string[], query: EditorStore['query']) =>
  (nodes || []).map((nodeId) => query.node(nodeId).node?.data?.props?.collectionId);
